<template>
  <div class="ticket--connected">
    <div class="ticket-box">
      <span v-if="isTicketExpired" class="tag">期限切れ</span>
      <span class="ticket-image">
        <ImgLazy
          :image-url="imageUrl"
          :alt-text="itemName"
          aspect-ratio="1"
          width="72"
          height="72"
          class="ticket-image-container"
        />
      </span>
      <div class="ticket-info">
        <p class="ticket__brand--small">
          {{ brandName }}
        </p>
        <p class="ticket__item-name">
          {{ itemName }}
        </p>
        <p class="ticket__item-min-unit">
          {{ itemSkuName }}
        </p>
        <span class="ticket__expired-date">{{ expiredDate }}</span>
        <span v-if="showExpiredDateNotice" class="ticket__expired-date-notice">
          期限を過ぎるとギフトの配送やご返金は承ることができません。
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ImgLazy from '../images/ImgLazy.vue'

export default {
  components: {
    ImgLazy
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    expiredDate: {
      type: String,
      required: true
    },
    isTicketExpired: {
      type: Boolean,
      required: false,
      default: false
    },
    showExpiredDateNotice: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.ticket {
  &--connected {
    font-size: 1.6rem;
    line-height: 1.6;
    color: $black;
    text-decoration: none;
    width: 100%;
    display: block;
    background-color: transparent;
  }

  &-box {
    display: flex;
  }

  &-image {
    height: 100%;
    font-size: 0;
  }

  &-image {
    .ticket-image-container {
      border-radius: 8px;
    }
  }

  &-info {
    overflow: hidden;
    width: 100%;
    padding-left: 16px;
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 4px;
  }

  &__item-name {
    font-weight: bold;
    font-size: 1.4rem;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: $black;
  }

  &__item-min-unit {
    font-weight: bold;
    font-size: 1.4rem;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: $black;
  }

  &__brand--small {
    line-height: 1.6;
    color: $gray-1;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
    font-size: 1.2rem;
  }

  &__expired-date {
    color: $primary;
    font-weight: bold;
    font-size: 1.4rem;
    line-height: 1.6;
    padding-top: 0;
    text-align: left;
  }

  &__expired-date-notice {
    @extend %minimal;
  }
}
</style>
